try {
    window.$ = window.jQuery = require("jquery");

    require('slick-carousel');
    require('aos');
    window.AOS = require('aos');
} catch (e) { }


document.addEventListener('DOMContentLoaded', function () {


    /**
     * initialise animations
     */
    AOS.init({
        offset: 80
    });

    /**
     * navigation
     */
    $('.linesight-nav-bottomlinks-mobilenav').on('click', function () {
        if ($(this).attr('aria-expanded') == 'true') {
            $('body').css('overflow-y', 'hidden');
        } else {
            $('body').css('overflow-y', 'auto');
        }
    });
    // Handle clicks outside navigation to close collapses
    document.addEventListener('click', function (event) {
        const nav = document.querySelector('.linesight-nav');
        const openCollapses = document.querySelectorAll('.linesight-nav-wrapper .collapse.show');
        if (!nav.contains(event.target) && openCollapses.length > 0) {
            openCollapses.forEach(collapse => {
                bootstrap.Collapse.getInstance(collapse).hide();
            });
        }
    });
    if($('.linesight-nav-breadcrumbs').length) {
        $(window).on('scroll', function() {
            const scrollPercentage = ($(window).scrollTop() / $(window).height()) * 100;
            
            if (scrollPercentage >= 5) {
                $('.linesight-nav-breadcrumbs').addClass('scrolled');
            } else {
                $('.linesight-nav-breadcrumbs').removeClass('scrolled');
            }
        });
    }
    $('.nav-anchor-links-toggle').on('click', function () {
        const $wrapper = $('.linesight-nav-breadcrumbs-wrapper');
        const hadDarkClass = $wrapper.hasClass('linesight-nav-breadcrumbs-wrapper-dark');
        
        if ($(this).attr('aria-expanded') == 'true') {
            $('.linesight-nav-breadcrumbs').addClass('breadcrumbs-collapsed');
            if (!hadDarkClass) {
                $wrapper.addClass('linesight-nav-breadcrumbs-wrapper-dark');
            }
        } else {
            $('.linesight-nav-breadcrumbs').removeClass('breadcrumbs-collapsed');
            if (!hadDarkClass) {
                $wrapper.removeClass('linesight-nav-breadcrumbs-wrapper-dark');
            }
        }
    });
    $('#nav-anchor-links a').on('click', function (e) {
        e.preventDefault();
        const targetId = $(this).attr('href');
        const $target = $(targetId);
        
        if ($target.length) {
            const navHeight = $('.linesight-nav').outerHeight() || 0;
            const offset = 50; 
            
            $('html, body').animate({
                scrollTop: $target.offset().top - navHeight - offset
            }, {
                duration: 500,
                easing: 'linear'
            });
        }
    });

    /**
     * carousels
     */
    $('.ffwd_image-grid-carousel').slick({
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 3,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '160px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0px',
            }
        }
        ],
    });

    const contentLinksCarouselSettings = {
        infinite: false,
        arrows: true,
        dots: true,
        slidesToShow: 4.01,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3.01,
                }
            },
            {
                breakpoint: 1150,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3.1,
                }
            },
            {
                breakpoint: 899,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2.1,
                }
            },
            {
                breakpoint: 499,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1.1,
                }
            }
        ],
    };
    $('.ffwd_content-links-carousel').slick(contentLinksCarouselSettings);
    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            $('.ffwd_content-links-carousel').slick('unslick');
            $('.ffwd_content-links-carousel').slick(contentLinksCarouselSettings);
        }, 250);
    });

    $('.ffwd_testimonial-carousel').slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        dots: true,
        centerMode: true,
        mobileFirst: true,
        centerPadding: '0',
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '160px',
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '70px',
            }
        },
        {
            breakpoint: 340,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '34px',
            }
        }
        ],
    });

    /**
     * counter
     */
    if ($('.ffwd_statistics-counter').length) {
        function startCounter(element) {
            var $element = $(element);
            var countTo = $element.data('value');
            var currentValue = parseInt($element.text(), 10);

            if (currentValue === countTo) {
                return;
            }

            function formatNumber(num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            $({ countNum: 0 }).animate({ countNum: countTo }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                    $element.text(formatNumber(Math.floor(this.countNum)));
                },
                complete: function () {
                    $element.text(formatNumber(this.countNum));
                }
            });
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startCounter(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        });

        $('.ffwd_statistics-counter').each(function () {
            observer.observe(this);
        });
    }

    /**
     * vertical card links
     */
    if ($('.ffwd_vertical-card').length > 0) {
        $('.ffwd_vertical-card').each(function () {
            var link = $(this).find('.ffwd_vertical-card-title').attr('href');
            $(this).attr('data-link', link);
        });

        let isSwiping = false;
        let isDragging = false;
        let clickTimeout;

        $('.ffwd_vertical-card').on('touchstart', function () {
            isSwiping = false;
            clearTimeout(clickTimeout);
        });

        $('.ffwd_vertical-card').on('touchmove', function () {
            isSwiping = true;
        });

        $('.ffwd_vertical-card').on('mousedown', function () {
            isDragging = false;
            clearTimeout(clickTimeout);
        });

        $('.ffwd_vertical-card').on('mousemove', function () {
            isDragging = true;
        });

        $('.ffwd_vertical-card').on('mouseup', function (e) {
            var link = $(this).data('link');
            if (link && !$(e.target).closest('a').length) {
                if (!isSwiping && !isDragging) {
                    clickTimeout = setTimeout(function () {
                        window.location.href = link;
                    }, 300);
                }
            }
        });

        $('.ffwd_vertical-card').on('mouseleave', function () {
            isDragging = false;
        });
    }

    /**
     * pause video on modal close
     */
    var videoModals = document.querySelectorAll('.ffwd_image-banner-video-modal');
    if (videoModals.length > 0) {
        videoModals.forEach(function (modal) {
            modal.addEventListener('hidden.bs.modal', function () {
                // Handle HTML5 video
                var video = modal.querySelector('video');
                if (video) {
                    video.pause();
                }
                
                // Handle Vimeo player
                var vimeoFrame = modal.querySelector('iframe[src*="vimeo"]');
                if (vimeoFrame) {
                    var vimeoPlayer = new Vimeo.Player(vimeoFrame);
                    vimeoPlayer.pause();
                }

                // Handle YouTube player
                var youtubeFrame = modal.querySelector('iframe[src*="youtube"]');
                if (youtubeFrame) {
                    var youtubeMessage = JSON.stringify({ event: 'command', func: 'pauseVideo' });
                    youtubeFrame.contentWindow.postMessage(youtubeMessage, '*');
                }
            });
        });
    }

    /**
     * floating key contact
     */
    if ($('.ffwd_key-contact').length > 0) {
        let hasScrolled = false;

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 150) {
                if (!hasScrolled) {
                    $('.ffwd_key-contact').addClass('visible');
                    hasScrolled = true;
                }
            } else {
                if (hasScrolled) {
                    $('.ffwd_key-contact').removeClass('visible');
                    hasScrolled = false;
                }
            }
        });
    }

    /**
     * start text animation for ffwd_statistics-letters
     */
    function startTextAnimation(element) {
        var $element = $(element);
        var textTo = $element.data('text');
        var currentText = $element.text();

        if (currentText === textTo) {
            return;
        }

        // Text scramble effect
        const scrambleText = (text) => {
            const upperCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const lowerCharacters = 'abcdefghijklmnopqrstuvwxyz';
            const baseInterval = text.length > 10 ? 20 : 30;
            const shuffleCount = 10;
            let currentIndex = 0;

            const scrambleNextLetter = () => {
                if (currentIndex < text.length) {
                    let scrambledText = text.split('');
                    
                    // Skip spaces, dashes, and commas
                    if (text[currentIndex] === ' ' || text[currentIndex] === '-' || text[currentIndex] === ',') {
                        scrambledText[currentIndex] = text[currentIndex];
                        $element.text(scrambledText.join(''));
                        currentIndex++;
                        scrambleNextLetter();
                        return;
                    }

                    let shuffleIterations = 0;

                    const shuffleInterval = setInterval(() => {
                        // Choose character pool based on target letter case
                        const characterPool = text[currentIndex] === text[currentIndex].toUpperCase() 
                            ? upperCharacters 
                            : lowerCharacters;
                        const randomChar = characterPool[Math.floor(Math.random() * characterPool.length)];
                        scrambledText[currentIndex] = randomChar;
                        $element.text(scrambledText.join(''));

                        shuffleIterations++;
                        if (shuffleIterations >= shuffleCount) {
                            clearInterval(shuffleInterval);
                            scrambledText[currentIndex] = text[currentIndex];
                            $element.text(scrambledText.join(''));
                            currentIndex++;
                            scrambleNextLetter();
                        }
                    }, baseInterval);
                }
            };

            scrambleNextLetter();
        };

        scrambleText(textTo);
    }

    if ($('.ffwd_statistics-letters').length) {
        const textObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startTextAnimation(entry.target);
                    textObserver.unobserve(entry.target);
                }
            });
        });

        $('.ffwd_statistics-letters').each(function () {
            textObserver.observe(this);
        });
    }

});